// Raggruppamento sezioni nella Sidebar — solo frontend, nessun campo DB.
// Nuova sezione aggiunta a `sezioni` senza entry qui finisce in 'amministrazione'.
export const MODULE_CATEGORIES = [
  { key: 'vendite', labelKey: 'categories.vendite' },
  { key: 'prodotti', labelKey: 'categories.prodotti' },
  { key: 'amministrazione', labelKey: 'categories.amministrazione' },
  { key: 'cantieri', labelKey: 'categories.cantieri' }
]

const DEFAULT_CATEGORY = 'amministrazione'

const TITLE_TO_CATEGORY = {
  Preventivi: 'vendite',
  Ordini: 'vendite',
  Fatture: 'vendite',
  Clienti: 'vendite',
  Sconti: 'vendite',
  Servizi: 'vendite',
  'E-commerce': 'vendite',
  Articoli: 'prodotti',
  Magazzino: 'prodotti',
  Scatole: 'prodotti',
  Fornitori: 'prodotti',
  Ricarico: 'prodotti',
  Variabili: 'prodotti',
  'Contabilità': 'amministrazione',
  Costi: 'amministrazione',
  Rimborsi: 'amministrazione',
  Canoni: 'amministrazione',
  Investimenti: 'amministrazione',
  Investitori: 'amministrazione',
  Analisi: 'amministrazione',
  Utenti: 'amministrazione',
  Aziende: 'amministrazione',
  Settaggi: 'amministrazione',
  Cantieri: 'cantieri',
  Costruzioni: 'cantieri',
  Progetti: 'cantieri',
  Resoconti: 'cantieri'
}

export function getModuleCategory (title) {
  return TITLE_TO_CATEGORY[title] || DEFAULT_CATEGORY
}
